module.exports = __webpack_public_path__ + "img/Cheer Megaphone40.ee1df33d.jpg";